import type { Action } from 'react-sweet-state';
import type { UIAnalyticsEvent } from '@atlaskit/analytics-next';
import { fireTrackAnalytics } from '@atlassian/jira-product-analytics-bridge';
import type { State } from '../../types';

export const fireTrackEvent =
	(
		analyticsEvent: UIAnalyticsEvent,
		selectedWorkspaceUuid: string,
		isSuccessful: boolean,
	): Action<State> =>
	() => {
		fireTrackAnalytics(analyticsEvent, 'oneClickConnect connectionCompleted', {
			selectedWorkspaceUuid,
			isSuccessful,
		});
	};
